import {createBrowserHistory} from 'history';
import {combineReducers} from 'redux';
import {configureStore, registerReducerTransformer} from '../Mobile-mmt-react-native/packages/legacy-commons/AppState/asyncStore';
import {createLogger} from "redux-logger";
import {shouldLogAction} from "../Mobile-mmt-react-native/packages/legacy-commons/Helpers/actionsLogger"; // defaults to localStorage for web and AsyncStorage for react-native
import { isMWeb } from "./ssrUtils";

const loggerMiddleware = createLogger({
  predicate: (getState, action) => __DEV__ && shouldLogAction(action)
});

const persistConfig = {
  key: 'root',
}

const preloadedState =
  isMWeb() ? window.__PRELOADED_STATE__ : undefined;

if (preloadedState) {
  preloadedState.railsLanding.departureDate = new Date(
    preloadedState.railsLanding.departureDate
  );
}

registerReducerTransformer(reducers => reducers);

const _dummyReducer = (state = {}) => state;
const reducer = combineReducers({__DUMMY__: _dummyReducer});


const store = configureStore(
  (state) => state,
  preloadedState,
);
export default store;
export const getStoreFromWeb = () => {
  return store;
};